module.exports = __webpack_public_path__ + "media/demo.d490cfa1.mp4";